var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAddPassage = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7727 3.7896H20.2425V1.2378C20.2425 0.5559 19.692 0 19.0155 0H18.9777C18.2982 0 17.7378 0.558 17.7378 1.2378V3.7896H15.2202C14.544 3.7896 13.992 4.3458 13.9809 5.0268V5.0646C13.9809 5.7609 14.5329 6.3207 15.2202 6.3207H17.7378V8.8629C17.7378 9.5451 18.2883 10.113 18.9777 10.0878H19.0152C19.6914 10.0878 20.2425 9.5316 20.2425 8.8629V6.3207H22.7727C23.4492 6.3207 24 5.7645 24 5.0781V5.0268C24 4.3458 23.4492 3.7896 22.7727 3.7896Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.395 6.763L12.393 6.853C12.393 7.383 12.591 7.858 12.938 8.218C13.021 8.299 13.111 8.373 13.205 8.438H6.37503V20.163C6.37503 20.623 6.00103 21 5.54403 21H3.83C3.60915 20.9984 3.3979 20.9095 3.24238 20.7527C3.08687 20.5959 2.99973 20.3839 3 20.163C3 19.702 3.374 19.325 3.83 19.325H4.66L4.63118 7.6C4.63118 7.14 5.00518 6.763 5.46218 6.763H12.395Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.626 8.767H15.211V9.724C15.211 10.474 15.652 11.124 16.286 11.428V19.325H17.116C17.3381 19.3249 17.5512 19.413 17.7084 19.5699C17.8655 19.7269 17.9539 19.9399 17.954 20.162C17.9541 20.3841 17.866 20.5972 17.7091 20.7543C17.5521 20.9115 17.3391 20.9999 17.117 21H15.456C15.2351 20.9984 15.0239 20.9095 14.8684 20.7527C14.7129 20.5959 14.6257 20.3839 14.626 20.163V8.767Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAddPassage);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/add_passage.bd77648c4fd6cbe60e1dcfdcc2378aab.svg";